import {IconButton, InputAdornment} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useState} from 'react';

const InputDefault = ({
  disabled,
  type,
  label,
  field,
  lookup,
  multiline,
  fullWidth,
  required,
  typeAddOrEdit,
  myLabel,
  formikProps,
}: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const submitAttempted = formikProps.submitCount > 0;
  const shouldShowErrors = (fieldName: string) =>
    Boolean(formikProps.errors[fieldName]) &&
    (formikProps.touched[fieldName] || submitAttempted);

  if (
    type === 'boolean' ||
    lookup.find((x) => x.column === field) ||
    field === 'reason' ||
    type === 'date' ||
    field === 'pdfName'
  )
    return null;

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }

  if (field === 'password') {
    const handleMouseDownPassword = (
      event: React.MouseEvent<HTMLButtonElement>,
    ) => {
      event.preventDefault();
    };

    const hasError = shouldShowErrors(field);

    return (
      <Field
        type={showPassword ? 'text' : 'password'}
        label={useMyLabel}
        name={field}
        variant="outlined"
        autoFocus
        required={required}
        fullWidth={fullWidth}
        component={TextField}
        multiline={multiline}
        disabled={disabled}
        error={hasError}
        helperText={
          hasError ? formikProps.errors[field] : formikProps.helperTextOverride
        }
        InputProps={
          typeAddOrEdit !== 'edit'
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={handleMouseDownPassword}
                      edge="end">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {}
        }
      />
    );
  } else {
    return (
      <Field
        type={type}
        label={useMyLabel}
        name={field}
        variant="outlined"
        autoFocus
        required={required}
        fullWidth={fullWidth}
        component={TextField}
        multiline={multiline}
        disabled={disabled}
        error={shouldShowErrors(field)}
        helperText={
          shouldShowErrors(field) ? formikProps.errors[field] : undefined
        }
      />
    );
  }
};

interface InputProps {
  disabled: boolean;
  type: string;
  label: string;
  field: string;
  lookup: any[];
  multiline: boolean;
  fullWidth: boolean;
  required: boolean;
  typeAddOrEdit: string;
  myLabel: string;
  formikProps: any;
  helperTextOverride?: React.ReactNode;
}
export default InputDefault;
